(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expert-testimonials')) {
    class ExpertTestimonials extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('[data-expert-carousel]');
        this.cells = Array.from(this.querySelectorAll('[data-expert-cell]'));
        this.tabs = Array.from(this.querySelectorAll('[data-expert-tab]'));

        if (!this.carousel || this.cells.length === 0) return;

        this.activeIndex = 0;
        this.isNavigating = false;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.goTo(Number(tab.dataset.index)), { signal });
        });

        this.carousel.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });

        // Theme-Editor: beim Auswählen eines Blocks direkt dorthin springen
        this.addEventListener('shopify:block:select', (event) => {
          const cell = event.target.closest('[data-expert-cell]');
          const index = this.cells.indexOf(cell);
          if (index !== -1) this.goTo(index, true);
        }, { signal });

        requestAnimationFrame(() => this.syncActive());
      }

      disconnectedCallback() {
        this.abortController?.abort();
        clearTimeout(this.scrollEndTimer);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      get paddingStart() {
        return parseFloat(getComputedStyle(this.carousel).paddingInlineStart) || 0;
      }

      goTo(index, instant = false) {
        const cell = this.cells[index];
        if (!cell) return;

        this.setActive(index);
        this.isNavigating = true;

        const carousel = this.carousel;
        const offset = cell.getBoundingClientRect().left - carousel.getBoundingClientRect().left - this.paddingStart;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        carousel.scrollTo({
          left: carousel.scrollLeft + offset,
          behavior: instant || reduceMotion ? 'auto' : 'smooth'
        });

        // Falls gar nicht gescrollt wird (bereits an Position), Sperre wieder lösen
        this.releaseAfterScroll();
      }

      onScroll() {
        this.releaseAfterScroll();

        // Während eines Klick-Scrolls nicht die Zwischen-Karten aktiv setzen
        if (this.isNavigating || this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.syncActive();
        });
      }

      releaseAfterScroll() {
        clearTimeout(this.scrollEndTimer);
        this.scrollEndTimer = setTimeout(() => {
          this.isNavigating = false;
          this.syncActive();
        }, 150);
      }

      syncActive() {
        const carousel = this.carousel;
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;

        // Am Ende angekommen: letzte Karte aktiv (die kann auf Mobil nie ganz links stehen)
        if (maxScroll > 0 && Math.abs(carousel.scrollLeft) >= maxScroll - 2) {
          this.setActive(this.cells.length - 1);
          return;
        }

        const reference = carousel.getBoundingClientRect().left + this.paddingStart;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.cells.forEach((cell, index) => {
          const distance = Math.abs(cell.getBoundingClientRect().left - reference);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.setActive(closestIndex);
      }

      setActive(index) {
        if (index === this.activeIndex && this.tabs[index]?.getAttribute('aria-current') === 'true') return;

        this.activeIndex = index;
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-current', i === index ? 'true' : 'false'));

        this.revealTab(this.tabs[index]);
      }

      // Aktiven Namen in der (auf Mobil horizontal scrollbaren) Liste sichtbar halten,
      // ohne die Seite vertikal zu verschieben
      revealTab(tab) {
        const nav = tab?.parentElement;
        if (!nav || nav.scrollWidth <= nav.clientWidth) return;

        const navRect = nav.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(nav).paddingInlineStart) || 0;

        if (tabRect.left < navRect.left + padding || tabRect.right > navRect.right - padding) {
          nav.scrollTo({
            left: nav.scrollLeft + tabRect.left - navRect.left - padding,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      }
    }

    customElements.define('expert-testimonials', ExpertTestimonials);
  }

  } catch(e) { console.error(e); }
})();
})();
